module.exports = __webpack_public_path__ + "media/fonts/ABC_Weise_Bold_201014-e0036d625f43d96cc2ce78a72caa3dc9.woff";